<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs v-show="xian1" @tab-click="handleClick_tab" v-model="activeName">
        <!-- 过滤器列表 -->
        <el-tab-pane label name="1">
          <span slot="label">
            {{ $t("logs.domain_3") }}
          </span>
          <div class="main">
            <el-button @click="tan()">{{ $t("logs.domain_4") }}</el-button>
          </div>
          <div class="switch1">
              <div class="table table_disk">
            <el-table v-loading="loading" :data="fileList_disk" :row-class-name="tableRowClassName" ref="multipleTable"  tooltip-effect="dark" style="width: 100%" >
                
                <el-table-column prop="AC_DATE" :label="$t('logs.user_list_manage1')" ></el-table-column>
                <el-table-column prop="SHOW_MINION" :label="$t('logs.user_list_manage2')" ></el-table-column>
                <el-table-column prop="QID" :label="$t('logs.user_list_manage3')" ></el-table-column>
                <el-table-column prop="IP" :label="$t('logs.user_list_manage4')" ></el-table-column>
                 <el-table-column prop="IP" :label="$t('logs.user_list_manage5')" ></el-table-column>
                  <el-table-column prop="IP" :label="$t('logs.user_list_manage6')" ></el-table-column>
                   <el-table-column prop="IP" :label="$t('logs.user_list_manage7')" ></el-table-column>
                    <el-table-column prop="IP" :label="$t('logs.user_list_manage8')" ></el-table-column>
                     <el-table-column prop="IP" :label="$t('logs.user_list_manage9')" ></el-table-column>
               
               

              
            </el-table>
             </div>
            <div class="table table_first table_fenye">
              <el-table
                v-loading="loading"
                :data="fileList"
                :row-class-name="tableRowClassName"
                ref="multipleTable"
               
                tooltip-effect="dark"
                style="width: 100%"
              
              >
                <el-table-column
                  prop="AC_DATE"
                  :label="$t('logs.group7_a4')"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="SHOW_MINION"
                  :label="$t('logs.notice4')"
                  width="96"
                ></el-table-column>
                <el-table-column
                  prop="QID"
                  :label="$t('logs.domain_1')"
                  width="96"
                ></el-table-column>
                <el-table-column
                  prop="IP"
                  :label="$t('logs.agent4')"
                ></el-table-column>

                <el-table-column
                  prop="SUBJECT"
                  :label="$t('logs.agent5')"
                  :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                  prop="SUBJECT"
                  :label="$t('logs.domain_2')"
                  :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                  prop="SIZE"
                  :label="$t('logs.Policy_list9')"
                  width="64"
                ></el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="120"
                >
                  <template slot-scope="scope">
                     <el-button @click="handleClick(scope.$index, scope.row)" type="text" size="small">{{ $t("table1.delete") }}</el-button>
                                    <el-button type="text" size="small" @click="edit1(scope.$index, scope.row)">{{ $t("table1.ditt") }}</el-button>
                  </template>
                </el-table-column>
              </el-table>

            </div>
              <!--  分页 -->
        <div class="fenye" >
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="totalnums"></el-pagination>
            <!--   <button @click="openPostWindow" class="el-icon-download1">{{
              $t("table.download")
            }}</button>
            <button @click="bulkpass" class="el-icon-finished1">{{
              $t("table.pass")
            }}</button>-->
             

        </div>
          </div>
        </el-tab-pane>
             <!-- 域查询 -->
                 <el-tab-pane label name="2">
 <span slot="label">
            {{ $t("logs.domain_6") }}
          </span>
           <div class="switch1">
            <div class="lie">
              <table>
                <tbody>
                  <tr>
                    <td>{{ $t("logs.group7_a4") }}:</td>
                    <td
                      style="flex-direction:row;padding-right:20px;align-items:center"
                    >
                      <el-select
                        v-model="qrydnmanner"
                        placeholder=""
                        style="margin-right:10px"
                      >
                        <el-option
                          v-for="item in qrydnmanner_arr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
<el-input
                        v-model="domainname"
                        placeholder
                        clearable
                      ></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("logs.Policy_list9") }}:</td>
                    <td
                      style="flex-direction:row;padding-right:20px;align-items:center"
                    >
                      <el-checkbox
                        v-model="qryactstat"
                        style="height:34px"
                      ></el-checkbox>

                    
                    </td>
                  </tr>

                  <tr>
                    <td>{{ $t("logs.domain_7") }}:</td>
                    <td
                      style="flex-direction:row;padding-right:20px;align-items:center"
                    >
                       <el-date-picker
                       format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
      v-model="cre_start_year"
      type="datetime"
      placeholder="选择日期时间">
    </el-date-picker>

                    
                    </td>
                  </tr>
    <tr>
                    <td>{{ $t("logs.domain_8") }}:</td>
                    <td
                      style="flex-direction:row;padding-right:20px;align-items:center"
                    >
                       <el-date-picker
                       format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
      v-model="exp_start_year"
      type="datetime"
      placeholder="选择日期时间">
    </el-date-picker>

                    
                    </td>
                  </tr>
                    <tr>
                    <td>{{ $t("logs.depart16") }}:</td>
                    <td
                      style="flex-direction:row;padding-right:20px;align-items:center"
                    >
                         <el-select
                        v-model="orderfield"
                        placeholder=""
                        style="margin-right:10px"
                      >
                        <el-option
                          v-for="item in orderfield_arr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>

                    
                    </td>
                  </tr>
                     <tr>
                    <td>{{ $t("logs.depart17") }}:</td>
                    <td
                      style="flex-direction:row;padding-right:20px;align-items:center"
                    >
                         <el-select
                        v-model="ordermanner"
                        placeholder=""
                        style="margin-right:10px"
                      >
                        <el-option
                          v-for="item in ordermanner_arr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>

                    
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td style="display:flex;flex-direction:row">
                      <el-button type="primary" @click="search_domain">{{
                        $t("logs.save_a")
                      }}</el-button>
                        <el-button type="danger" @click="off_domain">{{
                        $t("logs.save_b")
                      }}</el-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          </el-tab-pane >
      </el-tabs>
    
       <!-- 新建 -->
      <el-tabs v-show="xian2" class="edit_tab">
      <el-tab-pane label>
          <span slot="label">
            {{ $t("logs.domain_4") }}
          </span>
        <div class="main">
            <!-- <el-button @click="save_rule_hide()">{{
              $t("logs.Policy_back")
            }}</el-button> -->

            <el-alert
              :title="this.SHOW_RELATION1"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>

          <div class="table ruel_find">
            <div class="find">
              <!--域名-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.group7_a4") }}: </span>
                  <el-input
                    type="text"
                    v-model="domain"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--描述-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.policy8") }}: </span>
                  <el-input
                    type="text"
                    v-model="description"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--密码-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.user_list6") }}:
                  </span>
                  <el-input
                    type="password"
                    v-model="create_passwd1"
                    style="width:50%;"
                    show-password
                  >
                  </el-input>
                </div>
                <!--确认密码-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.user_list7") }}:
                  </span>
                  <el-input
                    type="password"
                    v-model="create_passwd2"
                    style="width:50%;"
                    show-password
                  >
                  </el-input>
                </div>
              </div>
              <!--容量-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.depart9") }}: </span>
                  <el-input
                    type="text"
                    v-model="create_maxspaces"
                    style="width:50%;"
                    clearable
                    placeholder="空间数范围：0到376657000M"
                  >
                  </el-input>

                </div>
                <!--最大网络磁盘-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.user_list_manage7") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_maxnetdisk"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--最大允许域-->
              <div class="find1">
                <div class="block block1">
                 <span class="ruel_find_text"
                    >{{ $t("logs.depart18") }}:
                  </span>
                  <el-select
                    v-model="create_active"
                    style="width:50%"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in create_active_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!--最大用户数-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.user_list_manage1") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_jobnumber"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>

           
            </div>

            <p class="create_information">{{ $t("logs.create_user11") }}</p>
            <!-- 基本信息 -->
            <div class="find" style="margin-top:0px">
              <!--公司-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.create_user12") }}: </span>
                  <el-input
                    type="text"
                    v-model="create_company"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--备注-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent11") }}: </span>
                  <el-input
                    type="text"
                    v-model="create_contact"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--QQ-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">QQ: </span>
                  <el-input
                    type="text"
                    v-model="create_qq"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--MSN-->
                <div class="block block1">
                  <span class="ruel_find_text">MSN: </span>
                  <el-input
                    type="text"
                    v-model="create_msn"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--座机-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user13") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_tele_number"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--Email-->
                <div class="block block1">
                  <span class="ruel_find_text">Email: </span>
                  <el-input
                    type="text"
                    v-model="create_email"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--省份-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user14") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_province"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--城市-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user15") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_city"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--手机-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user16") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_mobile_number"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--传真-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user17") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_fax_number"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--邮编-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user18") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_zipcode"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--联系地址-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user19") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_address"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--网站-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent12") }}: </span>
                  <el-input
                    type="text"
                    v-model="create_zipcode"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--到期日期-->
                <div class="block block1">
                  <span class="ruel_find_text" 
                    >{{ $t("logs.domain_1") }}:
                  </span>
                   <el-date-picker
                   style="width:50%"
      v-model="expiredate"
      type="datetime"
      placeholder="">
    </el-date-picker>
                </div>
              </div>
            </div>
            <!-- 	权限控制 -->
            <p class="create_information">{{ $t("logs.agent13") }}</p>

            <div class="find" style="margin-top:0px">
           
                <!--安全邮件-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent18") }}: </span>
                  <el-radio-group v-model="secure">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <!--企业地址簿-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent19") }}: </span>
                 <el-radio-group v-model="ent_addbook">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
                <!--语音邮件-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent20") }}: </span>
                  <el-radio-group v-model="voice">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <!--视频邮件-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent21") }}: </span>
                 <el-radio-group v-model="video">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
                <!--短信息-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent22") }}: </span>
                  <el-radio-group v-model="sms">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <!--彩信-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent23") }}: </span>
                 <el-radio-group v-model="mms">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
                 <!--WAP-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent24") }}: </span>
                  <el-radio-group v-model="wap">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <!--打印-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent25") }}: </span>
                 <el-radio-group v-model="print">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
                 <!--邮件监控-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent26") }}: </span>
                  <el-radio-group v-model="mon">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <!--邮件列表-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent27") }}: </span>
                 <el-radio-group v-model="maillist">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
                <!--允许设置附件大小-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent15") }}: </span>
                  <el-radio-group v-model="attach">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <!--POP3-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent29") }}: </span>
                 <el-radio-group v-model="pop">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <el-row>
            <el-button type="primary" @click="save_one()">{{
                    $t("tab.save")
                  }}</el-button>
                  <el-button type="danger" @click="cancel()">{{
                    $t("tab.cancel")
                  }}</el-button>
            </el-row>
          </div>
      
       
      
     
       </el-tab-pane>
      </el-tabs>
       <!-- 编辑 -->
         <el-tabs v-show="xian3" class="edit_tab">
      <el-tab-pane label >
          <span slot="label">
            {{ $t("logs.domain_5") }}
          </span>
           <div class="main">
            <!-- <el-button @click="save_rule_hide()">{{
              $t("logs.Policy_back")
            }}</el-button> -->

            <el-alert
              :title="this.SHOW_RELATION1"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>

          <div class="table ruel_find" v-loading="loading">
            <div class="find">
              <!--域名-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.group7_a4") }}: </span>
                  <el-input
                    type="text"
                    v-model="domain"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--描述-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.policy8") }}: </span>
                  <el-input
                    type="text"
                    v-model="description"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--密码-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.user_list6") }}:
                  </span>
                  <el-input
                    type="password"
                    v-model="create_passwd1"
                    style="width:50%;"
                    show-password
                  >
                  </el-input>
                </div>
                <!--确认密码-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.user_list7") }}:
                  </span>
                  <el-input
                    type="password"
                    v-model="create_passwd2"
                    style="width:50%;"
                    show-password
                  >
                  </el-input>
                </div>
              </div>
              <!--容量-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.depart9") }}: </span>
                  <el-input
                    type="text"
                    v-model="create_maxspaces"
                    style="width:50%;"
                    clearable
                    placeholder="空间数范围：0到376657000M"
                  >
                  </el-input>

                </div>
                <!--最大网络磁盘-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.user_list_manage7") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_maxnetdisk"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--最大允许域-->
              <div class="find1">
                <div class="block block1">
                 <span class="ruel_find_text"
                    >{{ $t("logs.depart18") }}:
                  </span>
                  <el-select
                    v-model="create_active"
                    style="width:50%"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in create_active_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <!--最大用户数-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.user_list_manage1") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_jobnumber"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>

           
            </div>

            <p class="create_information">{{ $t("logs.create_user11") }}</p>
            <!-- 基本信息 -->
            <div class="find" style="margin-top:0px">
              <!--公司-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.create_user12") }}: </span>
                  <el-input
                    type="text"
                    v-model="create_company"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--备注-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent11") }}: </span>
                  <el-input
                    type="text"
                    v-model="create_contact"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--QQ-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">QQ: </span>
                  <el-input
                    type="text"
                    v-model="create_qq"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--MSN-->
                <div class="block block1">
                  <span class="ruel_find_text">MSN: </span>
                  <el-input
                    type="text"
                    v-model="create_msn"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--座机-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user13") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_tele_number"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--Email-->
                <div class="block block1">
                  <span class="ruel_find_text">Email: </span>
                  <el-input
                    type="text"
                    v-model="create_email"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--省份-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user14") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_province"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--城市-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user15") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_city"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--手机-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user16") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_mobile_number"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--传真-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user17") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_fax_number"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--邮编-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user18") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_zipcode"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--联系地址-->
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.create_user19") }}:
                  </span>
                  <el-input
                    type="text"
                    v-model="create_address"
                    style="width:50%;"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
              <!--网站-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent12") }}: </span>
                  <el-input
                    type="text"
                    v-model="create_zipcode"
                    style="width:50%"
                    clearable
                  >
                  </el-input>
                </div>
                <!--到期日期-->
                <div class="block block1">
                  <span class="ruel_find_text" 
                    >{{ $t("logs.domain_1") }}:
                  </span>
                   <el-date-picker
                   style="width:50%"
      v-model="expiredate"
      type="datetime"
      placeholder="">
    </el-date-picker>
                </div>
              </div>
            </div>
            <!-- 	权限控制 -->
            <p class="create_information">{{ $t("logs.agent13") }}</p>

            <div class="find" style="margin-top:0px">
           
                <!--安全邮件-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent18") }}: </span>
                  <el-radio-group v-model="secure">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <!--企业地址簿-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent19") }}: </span>
                 <el-radio-group v-model="ent_addbook">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
                <!--语音邮件-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent20") }}: </span>
                  <el-radio-group v-model="voice">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <!--视频邮件-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent21") }}: </span>
                 <el-radio-group v-model="video">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
                <!--短信息-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent22") }}: </span>
                  <el-radio-group v-model="sms">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <!--彩信-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent23") }}: </span>
                 <el-radio-group v-model="mms">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
                 <!--WAP-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent24") }}: </span>
                  <el-radio-group v-model="wap">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <!--打印-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent25") }}: </span>
                 <el-radio-group v-model="print">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
                 <!--邮件监控-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent26") }}: </span>
                  <el-radio-group v-model="mon">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <!--邮件列表-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent27") }}: </span>
                 <el-radio-group v-model="maillist">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
                <!--允许设置附件大小-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent15") }}: </span>
                  <el-radio-group v-model="attach">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <!--POP3-->
                <div class="block block1">
                  <span class="ruel_find_text">{{ $t("logs.agent29") }}: </span>
                 <el-radio-group v-model="pop">
                    <el-radio :label="1">
                      {{ $t("logs.Policy_comb12") }}
                    </el-radio>
                    <el-radio :label="0">
                      {{ $t("logs.Policy_comb13") }}
                    </el-radio>
                  </el-radio-group>
                </div>
              </div>
            </div>
            <el-row>
           <el-button type="primary" @click="save2()">{{
                    $t("tab.save")
                  }}</el-button>
                  <el-button type="danger" @click="cancel2()">{{
                    $t("tab.cancel")
                  }}</el-button>
            </el-row>
          </div>
      <div >
      
       
      
      </div>
         </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {
      fileList_disk:[],
        activeName:'1',
        qrydnmanner:'',
        qrydnmanner_arr:[],
        domainname:'',
        qryactstat:true,
        cre_start_year:'',
        exp_start_year:'',
        orderfield:'',
        orderfield_arr:[],
        ordermanner:'',
        ordermanner_arr:[],
        create_username: "",
      create_name: "",
      create_passwd1: "",
      create_passwd2: "",
      create_maxspaces: "",
      create_maxnetdisk: "",
      create_depart_id: "",
      create_depart_id_arr: [],
      create_gender: "",
      create_gender_arr: [],
      create_isvip: "",
      create_isvip_arr: [],
      create_secure_sw: "",
      create_secure_sw_arr: [],
      create_spwd_hint_question: "",
      create_spwd_hint_question_arr: [],
      create_pwd_hint_question: "",
      create_pwd_hint_question_arr: [],
      create_pwd_hint_answer: "",
      create_duty: "",
      create_jobnumber: "",
      create_time: "",
      create_ip: "",
      create_active: "",
      create_active_arr: [],
      create_company: "",
      create_contact: "",
      create_qq: "",
      create_msn: "",
      create_tele_number: "",
      create_email: "",
      create_province: "",
      create_city: "",
      create_mobile_number: "",
      create_fax_number: "",
      create_zipcode: "",
      create_address: "",
      domain:'',
      description:'',
      expiredate:'',
     edit_domain_add:0,
      edit_domain_reduce:0,
      cre_subagent:0,
      secure:0,
      ent_addbook:0,
      pop:0,
      voice:0,
      video:0,
      sms:0,
      mms:0,
      wap:0,
      print:0,
      mon:0,
      maillist:0,
      attach:0,
      del_domain: 0,
      // filter_name
      filter_name: "",
      filter_describe: "",
      SHOW_RELATION1:'5',
      // 总数
      totalnums: 0,
      size: 0,
      // 每页条数
      pagesize: 0,
      //   默认前往第几页
      page: 1,
      col_search:[],
      xian2: false,
      xian3: false,
      xian1: true,
     
      tanchu: false,
      
      fileList: [],
     
      loading: false,
      tabs_page:'',
    
    };
  },
  mounted() {
   
    this.getFileList();
   
  },
  
  methods: {
      handleClick_tab(tab){
          console.log(tab)
          this.tabs_page=tab.index
      },
    //   与查询
    search_domain(){},
    off_domain(){
        this.activeName='1'
    },
  // 每页显示多少条 -- 切换
    handleSizeChange(val) {
      this.col = this.col_search;
      console.log(this.col, "给后台返回数据1");
      this.col.pagesize = val;

      console.log(this.col, "给后台返回数据2");

      this.getFileList_1();
    },
    // 当前第几页
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.col = this.col_search;
      console.log(this.col, "给后台返回数据1");
      this.col.page = val;
      console.log(this.col, "给后台返回数据2");

      this.getFileList_1();
    },
  
    handleClick(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          let filter_name = scope.FILTER_NAME;

          this.$axios
            .get("/api/adm/cgi/aspam.cgi", {
              params: {
                __mode: "del_filter",
                sid: sid,

                filter_name: filter_name,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },

    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
 
    // 数据
    // 加载
    getFileList() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "load_filter_list",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList = res.data.ret.datalist;
        
           
        
          }
        });
    },
    //
    save_one() {
      this.newadd = 1;
      this.save1();
    },
    save2() {
      this.newadd = 0;
      this.save1();
    },
    // 保存
    save1() {
      // this.xian2 = false;
      // this.tanchu = false;
      // this.xian1 = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

    
      // console.log(col, "222");

     

  

      let str = this.$qs.stringify({
        __mode: "save_filter",
        sid: sid,
      
      });
      // console.log(d)

      this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
        // console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
          this.xian2 = false;
          console.log(this.filter_name);
          this.edit2();
        }
      });
    },
    // 过滤器编辑
    edit2() {
      this.xian1 = false;
      this.xian3 = true;
      this.loading = true;
      // console.log(scope);
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      let filter_name = this.filter_name;
      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "edit_filter",
            sid: sid,
            filter_name: filter_name,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            // this.msgsize_unit=res.data.ret.msgsize_unit
            this.alink_out_relation = res.data.ret.alinkrelation;

            this.filter_name = res.data.ret.filter_name;
            this.filter_describe = res.data.ret.filter_describe;
            this.rootcondrelation = res.data.ret.rootcondrelation;
            this.rootcontrelation = res.data.ret.rootcontrelation;
            // let a = res.data.ret.condition
            this.chkcontent =
              res.data.ret.chkcontent == 1
                ? (this.chkcontent = true)
                : (this.chkcontent = false);
            this.chkcondition =
              res.data.ret.chkcondition == 1
                ? (res.data.ret.chkcondition = true)
                : false;
            this.chkalink =
              res.data.ret.chkalink == 1
                ? (res.data.ret.chkalink = true)
                : false;
            if (res.data.ret.condition) {
              this.tiaoa = res.data.ret.condition;
              console.log(this.tiaoa, "编辑的启用条件策略");
            }
            if (res.data.ret.content) {
              this.contentList = res.data.ret.content;
              console.log(this.contentList, "编辑的启用内容策略");
            }
            if (res.data.ret.alink) {
              this.alinkList = res.data.ret.alink;
              console.log(this.alinkList, "编辑的启用A链接扫描");
            }
            this.condition_namee0 = res.data.ret.q_condition_name;
            this.msgsize_typee0 = res.data.ret.q_condition_equal;
            this.sublen_typee = res.data.ret.q_condition_equal2;
            this.content_namee0 = res.data.ret.q_content_name;
            this.content_relationn0 = res.data.ret.q_content_relation;
            this.content_typee0 = res.data.ret.q_content_type;
            this.content_existt = res.data.ret.q_content_exist;
            this.content_matchh = res.data.ret.q_content_match;
            this.alink_namee0 = res.data.ret.q_alink_name;
            this.alink_relationn0 = res.data.ret.q_content_relation;
            this.alink_typee0 = res.data.ret.q_content_type;
            this.network_type00 = res.data.ret.q_condition_network;
            this.white_typee = res.data.ret.q_condition_white;
          }
        });
    },
    // 过滤器编辑
    edit1(index, scope) {
      this.xian1 = false;
      this.xian3 = true;
      this.loading = true;
      // console.log(scope);
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);
      let filter_name = scope.FILTER_NAME;
      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "edit_filter",
            sid: sid,
            filter_name: filter_name,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            // this.msgsize_unit=res.data.ret.msgsize_unit
            this.alink_out_relation = res.data.ret.alinkrelation;

            this.filter_name = res.data.ret.filter_name;
            this.filter_describe = res.data.ret.filter_describe;
            this.rootcondrelation = res.data.ret.rootcondrelation;
            this.rootcontrelation = res.data.ret.rootcontrelation;
            // let a = res.data.ret.condition
            this.chkcontent =
              res.data.ret.chkcontent == 1
                ? (this.chkcontent = true)
                : (this.chkcontent = false);
         
      
          }
        });
    },
    // 显示
    tan: function() {
      // this.tanchu = true;
      this.xian1 = false;
      this.xian2 = true;
     
    },
    // 打开关闭
    cancel: function() {
      this.xian2 = false;
      this.tanchu = false;
      this.xian1 = true;

     
        this.getFileList();
    },
    cancel2() {
      this.xian3 = false;
      this.xian2 = false;
      this.tanchu = false;
      this.xian1 = true;
   
     
      
      
        this.getFileList();
    },
    tanOff: function() {
      this.xian2 = false;
      this.tanchu = false;
      this.xian1 = true;
    },
  },
};
</script>

<style lang="less" scoped>
// IP白名单
.table02 {
  /deep/ .has-gutter th:nth-child(1) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(4) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(5) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(6) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(7) {
    text-align: center;
  }

  /deep/ .has-gutter th:nth-child(2) {
    text-align: left;
  }

  // 表格居中位置
  /deep/ .el-table__row td:nth-child(1) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(4) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(5) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(6) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(7) {
    text-align: center;
  }

  /deep/ .el-table__row td:nth-child(2) {
    text-align: left;
  }
}

.tiaojian_a {
  border: 1px solid #ddd;
  padding: 0 10px !important;
}

.tiaojian_a ul {
  display: flex;
  align-items: center;

  font-size: 12px;
  border-bottom: 1px solid #ddd;

  li {
    padding: 0 10px;
  }
}

.tiaojian_a ol {
  display: flex;
  font-size: 12px;
  align-items: center;

  li:nth-child(4) {
    padding-left: 10px;
  }

  li {
    padding-right: 10px;
  }

  /deep/.el-input {
    font-size: 12px;
  }
}

/deep/ .el-radio__label {
  font-size: 12px;
}

/deep/ .el-select {
  display: flex;
  justify-content: center;
}

// 添加
.add1 {
  display: flex;
  align-items: center;
  font-size: 12px;
}

// input 框高度
/deep/ .el-input__inner {
  height: 26px;
  padding: 0 5px;
}

// .lie table {
//     width: 100%;
// }

.lie tbody {
  // width: 100%;
  display: flex;
  flex-direction: column;
  margin: 15px;

  tr {
    border: 1px solid #ddd;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    margin-bottom: -1px;
    display: flex;
    align-items: center;
  }
}

/deep/ .el-alert__content {
  padding: 0;
}

.lie tbody td {
  font-size: 12px;
  height: 100%;
}

.lie tbody td:nth-child(1) {
  width: 100px;

  text-align: right;
  padding-right: 20px;
}

.lie tbody td:nth-child(2) {
  display: flex;
  border-left: 1px solid #ddd;

  flex-direction: column;

  .el-input {
    width: 200px;
  }

  padding-left: 20px;

  div {
    padding: 2px 4px;
    margin: 5px 0;
  }
}

// /deep/ .el-tabs__header {
//     margin: 0;
// }

// /deep/ .el-tabs__content {
//     padding: 0;
// }

.el-button {
  padding: 6px;
}





// 弹出框1






.table span {
  font-size: 14px;
}

// 时间
.time {
  display: flex;
  flex-direction: column;
  border: 1px solid #dcdfe6;
  background: #f1f1f1;
  margin: 10px 0;
}

.time1 {
  display: flex;
  align-items: center;
  padding: 2px 0 2px 14px;
  font-size: 14px;
}

// 手动设置
.time-text1 {
  padding-left: 20px;
}

// 后台管理控制
.back {
  display: flex;
  font-size: 14px;
  line-height: 30px;
  align-items: center;
  padding: 6px 0;
}

// .back div {
//   margin: 0 10px;
// }
.back .el-input {
  margin: 0 10px;
}

.backText {
  text-align: right;
}

.backText1 {
  color: #999;
  font-size: 12px;
}

.back .el-input {
  width: 20%;
  padding: 0;
}

.time2 {
  display: flex;
  margin-left: 190px;
  margin-top: 10px;
}

.time2 .el-button {
  padding: 8px 24px;
  // margin: 10px ;
}

// License
.time3 {
  display: flex;
  align-items: center;
  // margin-left: 150px;
  font-size: 14px;
  padding: 4px 10px;
}

// selece
.selece1 {
  width: 130px;
}

// input 框
.back1 .input1 {
  width: 100px;
  margin: 0 10px;
}




@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/fengye.less";


// .el-table ::-webkit-scrollbar {
//   width: 0px;
//   background: none;
// }

.main {
  padding: 0;
}

/deep/ .el-checkbox {
  display: flex;
  align-items: center;
  // line-height: 36px;
}

.main1 {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  border-bottom: 1px solid #dcdfe6;
  // line-height: 34px;
  height: 46px;
  // background: #f1f1f1;
  // margin: 0 14px 14px 14px;
  text-align: left;

  .el-button {
    margin-left: 15px;
    padding: 8px;
  }
}
.ruel_find .find {
  width: 100%;
}

.ruel_find .block {
  display: flex;
  align-items: center;
  // justify-content: center;
}

.ruel_find_text {
  margin-right: 8px;
  color: #0e2c5e;
  width: 150px;
  text-align: right;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
}

.ruel_find {
  /deep/ .el-button {
    padding: 8px 16px;
    // margin-left: 10px;
    font-size: 12px;
    // background: #eceff4;
    margin-top: 14px;
    margin-right: 10px;
  }
  }


.create_information {
  // margin: 0 14px;
  text-align: left;
  // padding-left: 14px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #0e2c5e;
  // background: #ffffff;
  // border: 2px solid #d2d7e6;
  border-bottom: 0;
  line-height: 40px;
}
.ruel_find_text_big{
  line-height: 18px;
padding: 10px 0;
}
.cursor_hover:hover {
  cursor: pointer;
}
.table_disk .el-table {
  height: auto;
  margin-bottom: 14px;

}
/deep/ .table_disk .el-table__row td{
    .cell {
        text-align: center;
    }

   
}
/deep/ .el-date-editor .el-input__inner{
    padding-left: 36px;
}
/deep/ .edit_tab .el-tabs__nav {
    padding-left: 14px;
}
</style>
